export enum ETypesLocation {
    DateFixe = 1,
    Variable = 2,
    Jour = 3,
    Semaine = 4,
    Mois = 5,
    Annee = 6
}